import React from 'react';
import './SafetyWarning.css';

export interface SafetyWarningProps {
    message: string;
    type: 'error' | 'warning';
    operationType?: 'R2F' | 'GSLA';
    onDismiss?: () => void;
    className?: string;
}

export const SafetyWarning: React.FC<SafetyWarningProps> = ({
    message,
    type,
    operationType,
    onDismiss,
    className = ''
}) => {
    const baseClasses = `safety-warning safety-warning--${type}`;
    const finalClasses = className ? `${baseClasses} ${className}` : baseClasses;

    return (
        <div className={finalClasses} role="alert" aria-live="polite">
            <div className="safety-warning__icon">
                {type === 'error' ? '🛡️' : '⚠️'}
            </div>
            <div className="safety-warning__content">
                <div className="safety-warning__title">
                    {type === 'error' ? 'SAFETY BLOCK' : 'SAFETY WARNING'}
                    {operationType && ` - ${operationType}`}
                </div>
                <div className="safety-warning__message">
                    {message}
                </div>
            </div>
            {onDismiss && (
                <button 
                    className="safety-warning__dismiss"
                    onClick={onDismiss}
                    aria-label="Dismiss warning"
                    type="button"
                >
                    ×
                </button>
            )}
        </div>
    );
};

export default SafetyWarning;